/* eslint-disable no-dupe-keys */
export default {
  vin_record: {
    name: 'VIN启动记录',
    // 属性（一般与对象内容匹配）
    prop: {
      vin: '车辆识别代码',
      car: '车辆',
      user: '用户',
      charge_station: '充电站',
      charger: '充电桩',
      service_provider: '运营商',
      service_provider_id: '运营商',
      verify_result: '结果',
      description: '描述',
      created_at: '启动时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    verify_results: {
      success: '成功',
      balance_not_enough: '余额不足',
      charger_forbidden: '无权在此桩充电',
      password_error: '密码错误',
      car_not_exist: '车辆未绑定',
      charger_start_failed: '桩启动失败'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询VIN/桩编号/站名'
    }
    // 详情页标签
  }
}
